import { render, staticRenderFns } from "./tuozhuai.vue?vue&type=template&id=71b9e922&scoped=true&"
import script from "./tuozhuai.vue?vue&type=script&lang=js&"
export * from "./tuozhuai.vue?vue&type=script&lang=js&"
import style0 from "./tuozhuai.vue?vue&type=style&index=0&id=71b9e922&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71b9e922",
  null
  
)

export default component.exports